import IScreenField from '../types/Screen/ScreenField'

const GetScreenFieldValue = (screenFields: IScreenField[], dataName: string) => {
    var field = screenFields.filter(field => field.dataName === dataName);
    return field.length > 0 ? field[0].value : "";
}

export default GetScreenFieldValue;